import apiClient from './apiClient';
import type {
  PortfolioKpis,
  PortfolioLink,
  PortfolioLinkCreatePayload,
  PortfolioMap,
} from '../types/portfolio';

const PORTFOLIO_URL = '/portfolio';

/** Portfolio API (lot L4): the org's semantic map, its KPIs and the saved rapprochements. */
export const portfolioService = {
  /** The cached map as the caller sees it; the backend rebuilds an outdated one in the background. */
  getMap: async (): Promise<PortfolioMap> => {
    const { data } = await apiClient.get<PortfolioMap>(`${PORTFOLIO_URL}/map`);
    return data;
  },

  /** Portfolio managers only (`can_rebuild`). */
  rebuildMap: async (): Promise<PortfolioMap> => {
    const { data } = await apiClient.post<PortfolioMap>(`${PORTFOLIO_URL}/map/rebuild`);
    return data;
  },

  getKpis: async (): Promise<PortfolioKpis> => {
    const { data } = await apiClient.get<PortfolioKpis>(`${PORTFOLIO_URL}/kpis`);
    return data;
  },

  listLinks: async (): Promise<PortfolioLink[]> => {
    const { data } = await apiClient.get<PortfolioLink[]>(`${PORTFOLIO_URL}/links`);
    return data;
  },

  createLink: async (payload: PortfolioLinkCreatePayload): Promise<PortfolioLink> => {
    const { data } = await apiClient.post<PortfolioLink>(`${PORTFOLIO_URL}/links`, payload);
    return data;
  },

  deleteLink: async (id: string): Promise<void> => {
    await apiClient.delete(`${PORTFOLIO_URL}/links/${id}`);
  },
};

export default portfolioService;
